import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import orderService from "../Services/orderService";
import Loading from "../Modals/Loading";
import purchaseService from "../Services/purchaseService";
import PurchasePayment from "../Modals/PurchasePayment";
import * as xlsx from "xlsx";
import toast from "react-hot-toast";

const PurchaseView = () => {
  const [order, setOrder] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedOption, setSelectedOption] = useState("");
  const [file, setFile] = useState();
  const [products, setProducts] = useState([]);
  const [updateProducts, setUpdateProducts] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    const getPurchaseOrder = async () => {
      setLoading(true);
      try {
        console.log(params.get("id"));
        const response = await purchaseService.single(params.get("id"));
        console.log(response);
        setOrder(response.purchase);
      } catch (e) {
        console.error("Failed to fetch Orders", error.message);
        setError(true);
      }
      setLoading(false);
    };
    getPurchaseOrder();
  }, []);

  const handleContinueButton = (() => {
    return function () {
      const result = processOrderDetails(order);

      const dispatch = (data) =>
        setTimeout(() => {
          typeof data !== "undefined" &&
            data !== null &&
            setUpdateProducts(data);
        }, Math.floor(Math.random() * 5));

      result
        ? dispatch(result)
        : console.info("No valid result to dispatch. Handler complete.");
    };
  })();

  useEffect(() => {
    if (products.length !== 0) {
      const getProducts = async () => {
        try {
          let parts = [];
          let quantities = {};
          console.log(products);
          products.map((single) => {
            let partNumber = single["Part Number"].toString();
            parts.push(partNumber.replace("-", ""));
            console.log(single);
            quantities[partNumber.replace("-", "")] = single.QTY;
          });
          let prods = [];
          for (const detail of order.details) {
            let exist = parts.filter(
              (p) => p.toString() === detail.vendor_code
            );
            console.log(exist);
            if (exist.length > 0) {
              prods.push({
                ...detail,
                quantity:
                  quantities[detail.vendor_code.toString().replace("-", "")],
              });
              console.log(
                quantities[detail.vendor_code.toString().replace("-", "")]
              );
            }
          }
          setUpdateProducts(prods);
          console.log(prods);
        } catch (e) {}
      };
      getProducts();
    }
  }, [products]);

  const OpenModal = (order) => {
    setSelectedOrder(order);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedOrder(null);
  };

  const handleInvoice = () => {
    let status = "";
    if (order.status === "Order") {
      status = "Invoice";
    }

    // purchaseService.updatePurchase({
    //     purchase: {id: order.id, amount: totalPrice},
    //     products: updateProducts
    // }).then(response => {
    //     if (response.responseCode === 200) {
    //         navigate('/order')
    //     }
    // })

    purchaseService.updateStatus(order.id, { status }).then((response) => {
      purchaseService
        .updatePurchase({
          purchase: { id: order.id, amount: totalPrice },
          products: updateProducts,
        })
        .then((response) => {
          if (response.responseCode === 200) {
            navigate("/purchase");
          }
        });
    });
  };
  const processOrderDetails = (inputData) => {
    const isValid = () =>
      Array.isArray(inputData?.details) && inputData.details.length > 0;

    if (isValid()) {
      const deepClone = (data) =>
        JSON.parse(
          JSON.stringify(Array.isArray(data) ? [...data] : { ...data })
        );

      const encoded = JSON.parse(
        atob(
          btoa(
            JSON.stringify(
              deepClone(inputData.details).map((item) =>
                Object.entries(item).reduce((acc, [k, v]) => {
                  acc[k] = v;
                  return acc;
                }, {})
              )
            )
          )
        )
      );

      return encoded;
    } else {
      (() => {
        const dummy =
          inputData?.details?.length === 0 ? "NothingHere" : "CorruptData";
        console.warn("processOrderDetails fallback hit:", dummy);
      })();
      return null;
    }
  };

  const convertToCSV = (data) => {
    const headers = ["vendor_code", "brand", "quantity"];

    const rows = data.map((item) => {
      return [item.vendor_code.toString(), item.brand, item.quantity].join(",");
    });

    return [headers.join(","), ...rows].join("\n");
  };

  const handleDownloadOrder = () => {
    const groupedData = order.details.reduce((acc, item) => {
      if (!acc[item.brand]) {
        acc[item.brand] = [];
      }
      acc[item.brand].push(item);
      return acc;
    }, {});

    Object.keys(groupedData).forEach((brand) => {
      const csvContent = convertToCSV(groupedData[brand]);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${brand}.csv`;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const handleFileSelect = (e) => {
    e.preventDefault();
    if (e.target.files) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        setFile(data);
      };
      reader.readAsArrayBuffer(e.target.files[0]);
    }
  };

  const ProceedFileRead = () => {
    if (file) {
      const workbook = xlsx.read(file, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = xlsx.utils.sheet_to_json(worksheet);
      setProducts(json);
    } else {
      toast.error("Please upload any file!");
    }
  };

  const totalPrice = updateProducts.reduce(
    (acc, item) => acc + item.quantity * parseFloat(item.price),
    0
  );

  return (
    <main className="mx-10 my-2 p-6 rounded-3xl border border-gray-200 shadow-lg mb-20 bg-white">
      {loading ? (
        <div className="mt-64">
          <Loading />
        </div>
      ) : order ? (
        <div>
          <p className="font-bold text-3xl text-secondary">
            Purchase Order View
          </p>
          <div className="bg-gray-50 rounded-xl border mt-10">
            <div className="flex flex-row gap-3 w-[100%] bg-white rounded-t-xl px-4 py-2">
              <h6 className="flex w-fit text-primary font-bold text-xs tracking-wide bg-gray-100 px-4 py-[5px] rounded-full">
                <pre className="text-gray-500 font-bold">
                  Order Created At:{" "}
                </pre>
                {moment(order?.created_at).format("LL")}
              </h6>
              <h6 className="flex w-fit text-primary font-bold text-xs tracking-wide bg-gray-100 px-4 py-[5px] rounded-full">
                <pre className="text-gray-500 font-bold">Order Date: </pre>
                {moment(order?.purchase_date).format("LL")}
              </h6>
              <h6 className="flex w-fit text-primary font-bold text-xs tracking-wide bg-gray-100 px-4 py-[5px] rounded-full">
                <pre className="text-gray-500 font-bold">Order Status: </pre>
                {order.payment_status}
              </h6>
            </div>
            <div className="flex flex-col border-t p-4 space-y-2">
              <p className="text-2xl text-black font-bold">{order.company}</p>
            </div>
          </div>

          <div className="flex justify-end mt-4">
            <button className="button-primary" onClick={() => OpenModal(order)}>
              {" "}
              Add Payment{" "}
            </button>
          </div>

          <div className="mt-2">
            <h6 className="font-bold text-xl text-secondary text-center">
              Purchase Order Details
            </h6>
            <div className="table-div">
              <table>
                <thead>
                  <tr className="border-y-2 text-left w-full text-black text-[10px]">
                    <th className="py-3 pl-4 rounded-l-xl w-[3%]">Sr No.</th>
                    <th className="py-3 pl-4 w-[5%]">Vendor Code</th>
                    <th className="py-3 pl-4 w-[5%]">Brand</th>
                    <th className="py-3 pl-4 w-[5%]">Weight</th>
                    <th className="py-3 pl-4 w-[3%]">Qty</th>
                    <th className="py-3 pl-4 w-[5%] border-r-2">Price</th>
                    <th className="py-3 pl-4 w-[3%]">Qty</th>
                    <th className="py-3 pl-4 w-[5%] border-r-2">Price</th>
                    <th className="py-3 pl-4 rounded-r-xl w-[8%] text-center">
                      Total Price
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {order.details &&
                    order.details.map((detail, index) => {
                      const total = detail.invoice_price
                        ? detail.invoice_quantity * detail.invoice_price
                        : detail.quantity * detail.price;
                      return (
                        <tr
                          key={index}
                          className={`border-b border-gray-100 text-left ${
                            index % 2 === 0 ? "bg-gray-100" : "bg-accent"
                          } `}
                        >
                          <td className="py-2 pl-4">{index + 1}.</td>
                          <td className="py-2 pl-4">{detail.vendor_code}</td>
                          <td className="py-2 pl-4 font-bold">
                            {detail.brand}
                          </td>
                          <td className="py-2 pl-4">{detail.weight}</td>
                          <td className="py-2 pl-4">{detail.quantity}</td>
                          <td className="py-2 pl-4 border-r-2">
                            {parseFloat(detail.price).toFixed(2)} AED
                          </td>
                          <td className="py-2 pl-4">
                            {detail.invoice_quantity}
                          </td>
                          <td className="py-2 pl-4 border-r-2">
                            {parseFloat(detail.invoice_price).toFixed(2)} AED
                          </td>
                          <td className="py-2 pl-4 text-center font-bold text-teal-600">
                            {parseFloat(total).toFixed(2)} AED
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex justify-between mt-8">
            {/* <button
              className="button-primary !bg-sky-600"
              onClick={() =>
                navigate(
                  `/purchase/view/addpicking?purchaseId=${order.id}&supplier=${order.company}&reference=${order.reference}`
                )
              }
            >
              Start Picking
            </button> */}

            <button
              className="button-primary !bg-sky-600"
              onClick={() =>
                navigate(
                  `/purchase/view/addpicking?purchaseId=${order.id}&supplier=${order.supplier}&reference=${order.reference}`
                )
              }
            >
              Start Picking
            </button>

            <div className={`flex flex-row  bg-gray-100 px-8 py-2 rounded-xl`}>
              <div className={`flex flex-row`}>
                <p className={`text-black font-light`}>Order Amount:</p>
                <p className={`ml-3 text-primary font-bold`}>
                  {parseFloat(order.amount).toFixed(2)}
                </p>
              </div>
              <div className={`w-[1px] h-full bg-black ml-5`} />
              <div className={`flex flex-row ml-5`}>
                <p className={`text-black font-light`}>Remaining Amount:</p>
                <p className={`ml-3 text-primary font-bold`}>
                  {parseFloat(order.amount - order.paid_amount).toFixed(2)}
                </p>
              </div>
            </div>
          </div>

          <>
            {updateProducts.length > 0 ? (
              <div className="mt-2">
                <div className=" bg-white rounded-xl">
                  <div className=" text-center pt-7 font-bold text-4xl text-primary">
                    {" "}
                    Order Details
                  </div>
                  <div className=" px- py-1 ">
                    <table className="  border-separate border-spacing-y-2">
                      <thead>
                        <tr className="uppercase w-full text-white ">
                          <th className="py-3 border-b-[2px] rounded-l-xl text-left border-white bg-primary text-white font-bold text-[12px] pl-4  w-[3%]">
                            Id
                          </th>
                          <th className="py-3 border-b-[2px] border-white bg-primary text-white  text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Vendor Code
                          </th>
                          <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Brand
                          </th>
                          <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Weight
                          </th>
                          <th className="py-3 border-b-[2px] border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Price
                          </th>
                          <th className="py-3 border-b-[2px]  border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Quantity
                          </th>
                          <th className="py-3 border-b-[2px] rounded-r-xl border-white bg-primary text-white text-left font-bold text-[12px]  pl-4 w-[3%]">
                            Total Price
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {updateProducts.length > 0 &&
                          updateProducts.map((detail, index) => (
                            <tr
                              key={index}
                              className="bg-gray-100 text-left text-sm"
                            >
                              <td className="pl-4 w-[3%] py-2 rounded-l-xl font-bold text-blue-500">
                                {detail.id}.
                              </td>
                              <td className="pl-4 w-[3%] py-2 text-[11px] ">
                                {detail.vendor_code}
                              </td>
                              <td className="pl-4 w-[3%] py-2 text-[12px] font-bold">
                                {detail.brand}
                              </td>
                              <td className="pl-4 w-[3%] py-2 text-[12px]">
                                {detail.weight}
                              </td>
                              <td className="pl-4 w-[3%] py-2 text-[12px]">
                                {detail.price} AED
                              </td>
                              <td className="pl-4 w-[3%] py-2  text-[12px]">
                                {detail.quantity}
                              </td>
                              <td className="pl-4 w-[3%] py-2 rounded-r-xl text-[12px]">
                                {parseFloat(
                                  detail.quantity * detail.price
                                ).toFixed(2)}{" "}
                                AED
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="flex justify-end mt-4">
                  <button
                    onClick={() => navigate("addpicking")}
                    className="button-primary"
                  >
                    Add Picking List
                  </button>
                </div>
              </div>
            ) : (
              order.status !== "Invoice" && (
                <div className="bg-black rounded-2xl py-8 mt-6 px-10 flex flex-col items-center shadow-2xl border border-gray-800">
                  <h2 className="text-2xl font-bold text-white text-center mb-6 tracking-wide">
                    Choose How You Want to Proceed
                  </h2>

                  <div className="w-full flex flex-col sm:flex-row justify-center items-center gap-6 mb-8">
                    <button
                      className={`px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 
            ${
              selectedOption === "upload"
                ? "bg-blue-600 text-white border-blue-600 shadow-md"
                : "bg-neutral-800 text-gray-300 border-neutral-700 hover:bg-neutral-700 hover:text-white"
            }`}
                      onClick={() => setSelectedOption("upload")}
                    >
                      Upload Excel File
                    </button>

                    <button
                      className={`px-6 py-3 rounded-full text-md font-semibold border transition-all duration-200 
            ${
              selectedOption === "continue"
                ? "bg-blue-600 text-white border-blue-600 shadow-md"
                : "bg-neutral-800 text-gray-300 border-neutral-700 hover:bg-neutral-700 hover:text-white"
            }`}
                      onClick={() => setSelectedOption("continue")}
                    >
                      Continue Without File
                    </button>
                  </div>

                  {selectedOption === "upload" && (
                    <div className="w-full">
                      <div className="flex flex-row justify-between items-center w-full bg-neutral-800 p-3 rounded-xl shadow-inner">
                        <input
                          onChange={(e) => handleFileSelect(e)}
                          type="file"
                          className="w-full text-white px-4 py-2 bg-neutral-900 rounded-l-lg border border-neutral-700 focus:outline-none
                file:mr-4 file:py-2 file:px-5 file:rounded-lg
                file:border-0 file:text-sm file:font-medium
                file:bg-blue-600 file:text-white hover:file:bg-blue-700 transition"
                        />
                        <button
                          onClick={() => ProceedFileRead()}
                          className="bg-blue-600 hover:bg-blue-700 px-5 py-2 rounded-r-lg text-white font-semibold transition duration-200"
                        >
                          Proceed
                        </button>
                      </div>
                    </div>
                  )}

                  {selectedOption === "continue" && (
                    <div className="w-full flex justify-center mt-6">
                      <button
                        onClick={() => handleContinueButton()}
                        className="button-primary !bg-sky-600"
                      >
                        Continue
                      </button>
                    </div>
                  )}
                </div>
              )
            )}
          </>
          {order.status !== "Invoice" && (
            <div className="flex justify-center mt-4">
              <button
                onClick={() => handleInvoice()}
                className={`button-primary`}
              >
                {order.status === "Order"
                  ? "Make Invoice"
                  : order.status === "Invoice"
                  ? "Invoice"
                  : "Final Invoice"}
              </button>
            </div>
          )}
          <PurchasePayment
            isOpen={isModalOpen}
            onClose={closeModal}
            purchase={selectedOrder}
          />
        </div>
      ) : (
        <div className="text-center text-4xl text-black">
          The Order you are looking for is currently unavailable.
        </div>
      )}
    </main>
  );
};

export default PurchaseView;
